import { GetProfileProgressByStartupID } from 'api/profile'
import React from 'react'
import { useDispatch } from 'react-redux';
import { SET_PROGRESS_DATA } from 'store/actions';
import { formatProgressData, getProgressLabel, requiredProgressFields } from 'utilities/index';

const ProgressHandler = ({ startup_id }) => {
    const dispatch = useDispatch();
    // console.log(startup_id, "startup_id")
    const { mutateAsync: getProfileProgress } = GetProfileProgressByStartupID({});
    React.useEffect(() => {
        // console.log(startup_id,"startup_id")
        getProfileProgress({ payload: { startup_id } }).then((data) => {
            if (data?.data?.data) {
                // console.log(data?.data?.data,'data?.data?.data')
                const { dataWithLabelsObject, requiredFieldsLabels, completion, round_id, dataWithLabels, weights, invitesUnlocked, scoreNotice } = formatProgressData({ response: data?.data?.data })
                dispatch({
                    type: SET_PROGRESS_DATA,
                    progressData: { ...dataWithLabelsObject },
                    requiredFields: requiredFieldsLabels,
                    completionPercentage: completion,
                    round_id: round_id,
                    weights,
                    invitesUnlocked,
                    scoreNotice,
                });
            }
        })
    }, [startup_id])

    return (
        null
    )
}

export default ProgressHandler